export default class {

    constructor() {

        $('a[href*="#"].scroll-to').on('click', (event) => {

            event.preventDefault();

            let top = $($(event.currentTarget).attr('href')).offset().top;

            $('html, body').animate({
                scrollTop: window.ViewPort.media === 'large' ? top - 160 : top - 20
            }, 500, 'linear');
        });

    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/src/core/Scroller.js